module.exports = __webpack_public_path__ + "static/media/TMS_ISO_27001_stamp_icon.9686d220.png";